import { Component, Input, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { PageRequest, PaginationPage } from 'src/app/common/modules/data-table.module/interfaces';
import { Consultation } from 'src/app/entities/consultation.entity';
import { Doctor } from 'src/app/entities/user.entity/doctor.entity';
import { AuthService } from 'src/app/services/auth.service/auth.service';
import { ConsultationService } from 'src/app/services/consultation.service';
import { ConsultationDto } from '../../Resovler/ConsultationDto';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-doctor-consultations-table',
  templateUrl: './doctor-consultations-table.component.html',
  styleUrls: ['./doctor-consultations-table.component.css']
})
export class DoctorConsultationsTableComponent implements OnInit {
  @Input() currentPage: number = 0;
  @Input() perPage: number = 10;
  @Input() pageRequest!: (pageRequest: PageRequest) => Promise<PaginationPage<ConsultationDto>>;
  @Input() emptyMessage?: string;
  doctorConsultations: Array<ConsultationDto> = new Array();

  constructor(
    private consultationsService: ConsultationService,
    private authService: AuthService,
    private toasterService: ToastrService
  ) { }

  get doctor(): Doctor {
    return this.authService.getCurrentUser() as Doctor;
  }

  ngOnInit(): void {
    this.currentPage = 0;
    
  }
avatarSrc(consultation: ConsultationDto): string {
  if (!consultation.patientImage) {
    return 'assets/img/user-avatar.png';
  }
  // Si l'image est déjà une URL absolue (ex: photo de profil Google OAuth),
  // on ne la préfixe pas avec le storage endpoint interne.
  if (/^https?:\/\//i.test(consultation.patientImage)) {
    return consultation.patientImage;
  }
  return `http${environment.API_SSL ? 's' : ''}://${environment.API_HOST_NAME}${environment.PORT ? ':' + environment.PORT : ''}/${environment.STORAGE_ENDPOINT}/${consultation.patientImage}`;
}
  onDeleteConsultation(index: number) {
    if (confirm('Êtes-vous sûr(e) de vouloir supprimer cette   consultation ?'))
      this.consultationsService.delete(this.doctorConsultations[index].id).subscribe((res) => {
        this.toasterService.success('Consultation has deleted');
        this.doctorConsultations.splice(index, 1);
      }, error => {
        this.toasterService.error('Enable to delete Consultation')
      });
  }
}
